import { HTTP as http } from "../../http";

const PREFIX = "/calendario";

export default {
    getCalendar: data => {
        return http.post(PREFIX + "/getCalendar", data);
    }
};
